{
    "(save {highestYearlyDiscount}%)": "(säästa {highestYearlyDiscount}%)",
    "{amount} days free": "{amount} päeva tasuta",
    "{amount} off": "{amount} soodustust",
    "{amount} off for first {number} months.": "{amount} soodustust esimeseks {number} kuuks.",
    "{amount} off for first {period}.": "{amount} soodustust esimeseks {period}ks.",
    "{amount} off forever.": "{amount} soodustust igaveseks.",
    "{buyerName} has gifted you a {duration}-month {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a {duration}-month {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a {duration}-year {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% allahindlus",
    "{duration} membership": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} ei saa enam {newsletterName} uudiskirja.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} ei saa enam e-kirju, kui keegi vastab teie kommentaaridele.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} ei saa enam seda uudiskirja.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} päeva tasuta",
    "{years} years": "",
    "+1 (123) 456-7890": "+1 (123) 456-7890",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Konto",
    "Account details updated successfully": "",
    "Account settings": "Konto seaded",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Pärast tasuta prooviversiooni lõppu võetakse teilt tasu valitud taseme tavahinna eest. Saate alati enne seda tühistada.",
    "Already a member?": "Juba liige?",
    "An error occurred": "",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Tekkis ootamatu viga. Palun proovige uuesti või <a>võtke ühendust toega</a>, kui viga püsib.",
    "Back": "Tagasi",
    "Back to Log in": "Tagasi sisselogimise juurde",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Must Reede",
    "Bluesky": "",
    "Cancel anytime.": "Tühistage igal ajal.",
    "Cancel subscription": "Tühista tellimus",
    "Canceled": "",
    "Cancellation reason": "Tühistamise põhjus",
    "Change": "Muuda",
    "Change plan": "Muuda paketti",
    "Check spam & promotions folders": "Kontrollige rämpsposti ja reklaamide kaustu",
    "Check with your mail provider": "Kontrollige oma e-posti teenusepakkujaga",
    "Check your inbox to verify email update": "",
    "Choose": "Vali",
    "Choose a different plan": "Vali teine pakett",
    "Choose a plan": "Vali pakett",
    "Choose a tier": "",
    "Choose your newsletters": "Vali oma uudiskirjad",
    "Click here to retry": "Klõpsake siia, et uuesti proovida",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Sulge",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "Kommentaarid",
    "Complimentary": "Tasuta",
    "Confirm": "Kinnita",
    "Confirm cancellation": "Kinnita tühistamine",
    "Confirm subscription": "Kinnita tellimus",
    "Contact support": "Võta ühendust toega",
    "Continue": "Jätka",
    "Continue subscription": "Jätka tellimust",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "",
    "Could not sign in. Login link expired.": "Ei saanud sisse logida. Sisselogimislink on aegunud.",
    "Could not update email! Invalid link.": "E-posti ei saanud uuendada! Vigane link.",
    "Create a new contact": "Loo uus kontakt",
    "Current plan": "Praegune pakett",
    "Delete account": "Kustuta konto",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Ei soovinud seda teha? Halda oma eelistusi <button>siin</button>.",
    "Don't have an account?": "Pole kontot?",
    "Edit": "Muuda",
    "Email": "E-post",
    "Email confirmation link expired.": "",
    "Email it to them now": "",
    "Email newsletter": "E-posti uudiskiri",
    "Email newsletter settings updated": "",
    "Email preferences": "E-posti eelistused",
    "Email preferences updated.": "",
    "Emails": "E-kirjad",
    "Emails disabled": "E-kirjad keelatud",
    "Ends {offerEndDate}": "Lõpeb {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "Sisestage oma e-posti aadress",
    "Enter your name": "Sisestage oma nimi",
    "Error": "Viga",
    "Expires {expiryDate}": "Aegub {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "",
    "Failed to log in, please try again": "",
    "Failed to log out, please try again": "",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "",
    "Failed to send magic link email": "",
    "Failed to send verification email": "",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "",
    "Failed to update account details": "",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "",
    "Failed to verify code, please try again": "",
    "Forever": "Igavesti",
    "Free Trial – Ends {trialEnd}": "Tasuta prooviversioon – Lõpeb {trialEnd}",
    "From": "",
    "Get help": "Hangi abi",
    "Get in touch for help": "Võta ühendust abi saamiseks",
    "Get notified when someone replies to your comment": "Saa teavitus, kui keegi vastab sinu kommentaarile",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Anna tagasisidet sellele postitusele",
    "Help! I'm not receiving emails": "Aidake! Ma ei saa e-kirju",
    "Here are a few other sites you may enjoy.": "Siin on mõned teised saidid, mis võiksid teile meeldida.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Kui uudiskiri märgitakse rämpspostiks, keelatakse sellele aadressile automaatselt e-kirjad, et te ei saaks enam soovimatuid sõnumeid.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Kui rämpspostiteatamise kaebus oli juhuslik või soovite uuesti e-kirju saada, saate e-kirjade tellimuse uuesti tellida, klõpsates eelmisel ekraanil olevat nuppu.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Kui tühistate oma tellimuse nüüd, jääb teile juurdepääs kuni {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Kui teil on ettevõtte või valitsuse e-posti konto, pöörduge oma IT-osakonna poole ja paluge neil lubada e-kirjade vastuvõtmine aadressilt {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Sisselogimislink on saadetud teie postkasti. Kui see ei saabu 3 minuti jooksul, kontrollige kindlasti oma rämpsposti kausta.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Kui soovite uuesti e-kirju saada, on järgmiseks parimaks sammuks kontrollida oma registreeritud e-posti aadressi probleemide suhtes ja seejärel klõpsata eelmisel ekraanil uuesti tellimisnuppu.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Kui te ei saa e-posti uudiskirja, mille olete tellinud, on siin mõned asjad, mida kontrollida.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Kui olete kõik need kontrollid läbi viinud ja te ikka ei saa e-kirju, võite abi saamiseks pöörduda aadressil {supportAddress}.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Kui uudiskirja saatmise katsel saadakse püsiv tõrge, keelatakse kontol e-kirjad.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Lisage oma e-posti kliendis {senderEmail} oma kontaktide loendisse. See annab teie e-posti teenusepakkujale märku, et sellelt aadressilt saadetud e-kirju tuleks usaldada.",
    "Invalid email address": "Vigane e-posti aadress",
    "Invalid verification code": "",
    "Jamie Larson": "Jamie Larson",
    "jamie@example.com": "jamie@example.com",
    "Less like this": "Vähem sellist",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Veenduge, et e-kirjad ei satuks kogemata teie postkasti rämpsposti või reklaamide kausta. Kui need on seal, klõpsake \"Märgi mitte-rämpspostiks\" ja/või \"Liiguta postkasti\".",
    "Manage": "Halda",
    "Maybe later": "Võib-olla hiljem",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "Liikmestaatus pole saadaval, võtke juurdepääsu saamiseks ühendust omanikuga.",
    "month": "kuu",
    "Monthly": "Igakuine",
    "More like this": "Rohkem sellist",
    "More options": "",
    "Name": "Nimi",
    "Need more help? Contact support": "Vajate rohkem abi? Võtke ühendust toega",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Uudiskirjad võidakse teie kontol keelata kahel põhjusel: eelmine e-kiri märgiti rämpspostiks või e-kirja saatmise katse põhjustas püsiva tõrke (tagasipõrke).",
    "No member exists with this e-mail address.": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Ei saa e-kirju?",
    "Now check your email!": "Nüüd kontrollige oma e-posti!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Kui olete uuesti tellinud ja te ikka ei näe e-kirju oma postkastis, kontrollige oma rämpsposti kausta. Mõned postkasti teenusepakkujad säilitavad varasemaid rämpspostikaebusi ja jätkavad e-kirjade märkimist. Kui see juhtub, märkige viimane uudiskiri 'Mitte rämpspost', et see liiguks tagasi teie põhipostkasti.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Püsiv tõrge (tagasipõrge)",
    "Phone number": "Telefoninumber",
    "Plan": "Pakett",
    "Plan checkout was cancelled.": "Paketi tellimuse vormistamine tühistati.",
    "Plan upgrade was cancelled.": "Paketi uuendamine tühistati.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Palun võtke ühendust {supportAddress}, et kohandada oma tasuta tellimust.",
    "Please enter {fieldName}": "Palun sisestage {fieldName}",
    "Please fill in required fields": "Palun täitke kohustuslikud väljad",
    "Podcasts": "",
    "Re-enable emails": "Luba e-kirjad uuesti",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Soovitused",
    "Redeem your gift": "",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "Uueneb hinnaga {price}.",
    "Resume subscription": "",
    "Retry": "Proovi uuesti",
    "Save": "Salvesta",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Sisselogimislingi saatmine...",
    "Sending...": "Saatmine...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Näita kõiki",
    "Sign in": "Logi sisse",
    "Sign out": "Logi välja",
    "Sign up": "Registreeru",
    "Signup error: Invalid link": "Registreerimise viga: Vigane link",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "Midagi läks valesti, palun proovige hiljem uuesti.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "",
    "Spam complaints": "Rämpsposti kaebused",
    "Start {amount}-day free trial": "Alusta {amount}-päevast tasuta prooviversiooni",
    "Starting {startDate}": "Algab {startDate}",
    "Starting today": "Algab täna",
    "Submit feedback": "Saada tagasiside",
    "Subscribe": "Telli",
    "Subscribed": "Tellitud",
    "Subscription plan updated successfully": "",
    "Success": "Õnnestus",
    "Success! Check your email for magic link to sign-in.": "Õnnestus! Kontrollige oma e-posti, et leida maagiline sisselogimislink.",
    "Success! Your account is fully activated, you now have access to all content.": "Õnnestus! Teie konto on täielikult aktiveeritud, teil on nüüd juurdepääs kogu sisule.",
    "Success! Your email is updated.": "Õnnestus! Teie e-post on uuendatud.",
    "Successfully unsubscribed": "Tellimus on edukalt tühistatud",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Täname tellimise eest. Enne kui alustate lugemist, on allpool mõned teised saidid, mis võiksid teile meeldida.",
    "Thank you for your support": "Täname teid toetuse eest",
    "Thank you for your support!": "Täname teid toetuse eest!",
    "Thanks for the feedback!": "Täname tagasiside eest!",
    "That didn't go to plan": "See ei läinud plaanipäraselt",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Meie käsutuses olev e-posti aadress teie jaoks on {memberEmail} — kui see pole õige, saate seda muuta oma <button>konto seadete alas</button>",
    "There was a problem submitting your feedback. Please try again a little later.": "Teie tagasiside esitamisel tekkis probleem. Palun proovige natuke hiljem uuesti.",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "",
    "There was an error sending the email, please try again": "",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "See sait on ainult kutsetega, juurdepääsu saamiseks võtke ühendust omanikuga.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "",
    "This site only accepts paid members.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Registreerimise lõpetamiseks klõpsake oma postkastis kinnituslingile. Kui see ei saabu 3 minuti jooksul, kontrollige oma rämpsposti kausta!",
    "To continue to stay up to date, subscribe to {publication} below.": "",
    "Too many attempts try again in {number} days.": "",
    "Too many attempts try again in {number} hours.": "",
    "Too many attempts try again in {number} minutes.": "",
    "Too many different sign-in attempts, try again in {number} days": "",
    "Too many different sign-in attempts, try again in {number} hours": "",
    "Too many different sign-in attempts, try again in {number} minutes": "",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "Proovige tasuta {amount} päeva, seejärel {originalPrice}.",
    "Unable to initiate checkout session": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Avage juurdepääs kõigile uudiskirjadele, hakates tasuliseks tellijaks.",
    "Unsubscribe from all emails": "Tühista kõikide e-kirjade tellimus",
    "Unsubscribed": "Tellimus tühistatud",
    "Unsubscribed from all emails.": "Kõikide e-kirjade tellimus tühistatud",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "E-kirjade tellimusest loobumine ei tühista teie tasulist tellimust {title}-le",
    "Update": "Uuenda",
    "Update your preferences": "Uuendage oma eelistusi",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Kinnituslink saadetud, kontrollige oma postkasti",
    "Verify your email address is correct": "Veenduge, et teie e-posti aadress on õige",
    "Verifying...": "",
    "View plans": "Vaata plaane",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Me ei saanud teie tellimust tühistada, kuna e-posti aadressi ei leitud. Palun võtke ühendust saidi omanikuga.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Tere tulemast tagasi, {name}!",
    "Welcome back!": "Tere tulemast tagasi!",
    "Welcome to {siteTitle}": "Tere tulemast {siteTitle}-sse",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Kui postkast ei võta e-kirja vastu, nimetatakse seda tavaliselt tagasipõrkeks. Paljudel juhtudel võib see olla ajutine. Kuid mõnel juhul võib tagasipõrkunud e-kiri tagastada püsiva tõrke, kui e-posti aadress on kehtetu või seda pole olemas.",
    "Why has my email been disabled?": "Miks on minu e-post välja lülitatud?",
    "X (Twitter)": "",
    "year": "",
    "Yearly": "Aastane",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Teil on praegu tasuta liikmelisus, täieliku juurdepääsu saamiseks uuendage tasulisele tellimusele.",
    "You have been successfully resubscribed": "Olete edukalt uuesti tellinud",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Te ei saa praegu e-kirju",
    "You're not receiving emails": "Te ei saa e-kirju",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Te ei saa e-kirju, kuna kas märkisite hiljutise sõnumi rämpspostiks või sõnumeid ei saanud teie antud e-posti aadressile kohale toimetada.",
    "You've been gifted a {duration}-month {tierName} membership_one": "",
    "You've been gifted a {duration}-month {tierName} membership_other": "",
    "You've been gifted a {duration}-month {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a {duration}-month {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a {duration}-year {tierName} membership": "",
    "You've been gifted a {duration}-year {tierName} membership to {siteTitle}": "",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "Olete edukalt sisse loginud.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Olete edukalt tellinud <strong>{siteTitle}</strong>",
    "Your account": "Teie konto",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Teie sisend aitab kujundada seda, mida avaldatakse.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Teie tellimus aegub {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Teie tellimus uueneb {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Teie tellimus algab {subscriptionStart}"
}
